import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import useCountry from '../hooks/useCountry';

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ReviewsPage from "../pages/ReviewsPage";
import WritePage from "../pages/WritePage";
import ErrorPage from "../pages/ErrorPage";

import axios from '../utils/axios';
// ------------------------------------------------------------------------------------------

function ResolveSlug(props) 
{
    const patternCompanyID = new RegExp('^[0-9]+/?$');
    const country = useCountry();
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(false);
    const [ directID, setDirectID ] = useState(false);
    const criteria = useParams()['*'];

    useEffect( () => { 
        if ( patternCompanyID.test(Number(criteria)) )
        {
            // If we have a company ID we should try to redirect to it's slug (and if we can't, then we can 
            // just display the page anyway without redirecting)

            console.log('Resolve: found a company ID');
            axios.post('/app/internal/resolve-slug', { id: criteria, country: country?.id })
            .then((response) => {
                if ( response.data?.slug?.length > 1 ) { 
                    if ( props?.writePage === true ) { 
                        window.location.replace( '/write/' + response?.data?.slug );
                    } else { 
                        window.location.replace( response?.data?.slug );
                    }
                } else { 
                    console.log('Resolution to a full slug failed, so displaying page by direct ID');
                    setDirectID(criteria);
                    setLoading(false);
                }
            })
            .catch((response) => { 
                console.error(response);
                setDirectID(criteria); 
                setLoading(false);
            })

        } else { 

            // If we have a slug we need to check if it's valid - if it is, we don't need to redirect but we
            // do need to grab the company ID
            console.log('Resolve: found a slug');

            axios.post('/app/internal/resolve-slug', { slug: criteria, country: country?.id })
            .then((response) => {
                console.log('Slug resolution: returned a successful ID of ' + response.data?.id );
                setDirectID( response.data?.id );     
                setLoading( false );               
            })
            .catch((response) => { 
                console.error(response);
                setError(true);
                setLoading(false);
            })
        }        

    // eslint-disable-next-line
    }, []);
    

    return (
        <>

        { /* When a company ID has matched (with or without full slug resolution */ }
        { !error && !loading && directID !== false && props?.writePage === true && ( <WritePage companyID={directID} /> ) }
        { !error && !loading && directID !== false && props?.writePage === false && ( <ReviewsPage companyID={directID} /> ) }

        { /* Resolution entirely failed */ }
        { error && ( <ErrorPage content={
            <Stack direction="column">
                <Typography variant="h5" component="h1">Not found</Typography>
                <Typography variant="body2" component="div">We couldn't find the page or company that you were looking for.</Typography>
            </Stack> 
        } /> ) }
        </>
    );

}

export default ResolveSlug;